class QuizButton extends HTMLElement {
  constructor() {
    super();
    this.quizSection = document.querySelector('.octane-ai-quiz')?.closest('.section') || document.querySelector('.octane-ai-quiz-rendered')?.closest('.section');
    this.quizSection?.classList.add('hidden');
    this.addEventListener('click', ()=>{
      if(!document.querySelector('.octane-ai-quiz-rendered')) return;
      const event = new Event("click");
      document.querySelector('.oct-quiz-btn')?.dispatchEvent(event);
      setTimeout(() => {
        this.quizSection?.classList.remove('hidden');
        this.closest('.hero')?.classList.add('hidden');
      }, 1500);
    })
  }
}

if (!customElements.get('quiz-button')) {
  customElements.define('quiz-button', QuizButton);
}